import request from './request';
const axios = {
  get(url, params, option) {
    const config = {
      method: 'get',
      url: url,
      loading: true,
      ...option
    };

    if (params) config.params = params;
    return request(config);
  },
  post(url, data, option) {
    const config = {
      method: 'post',
      url: url,
      loading: true,
      ...option
    };
    // `data` is the data to be sent as the request body
    if (data) config.data = data;
    return request(config);
  },
  put(url, data, option) {
    const config = {
      method: 'put',
      url: url,
      loading: true,
      ...option
    };
    // `data` is the data to be sent as the request body
    if (data) config.data = data;
    return request(config);
  },
  delete(url, params, option) {
    const config = {
      method: 'delete',
      url: url,
      loading: true,
      ...option
    };
    if (params) config.params = params;
    return request(config);
  }
};

export default axios;
